import { render, staticRenderFns } from "./topBack.vue?vue&type=template&id=71ec27f0&scoped=true&"
import script from "./topBack.vue?vue&type=script&lang=js&"
export * from "./topBack.vue?vue&type=script&lang=js&"
import style0 from "./topBack.vue?vue&type=style&index=0&id=71ec27f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec27f0",
  null
  
)

export default component.exports